import {ChangeDetectorRef, Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'demoApp';
  name = 'Angular';
  private applicationHelpUrl: string;
  hasLoaded: boolean;
  constructor(private ref: ChangeDetectorRef) {}
  ngOnInit() {
    this.hasLoaded = false;
    this.ref.detectChanges();
  }
  help() {
    let lang = window.navigator.languages ?
      window.navigator.languages[0]
      : (window.navigator.language || window.navigator.language);
    if (lang != null) {
      lang = lang.substring(0, 2);
    } else {
      lang = 'en';
    }
    const topicId = 2583;
    this.applicationHelpUrl = '/help?topicid=' + topicId + '&culture=' + lang;
  }
}
